<template>
  <div>
    <b-container class="text-left ">
      <h1 class="text-left mt-2 mb-1">Személyes adatok</h1>
      <div class="bordered-container mt-4">
        <b-form>
          <b-row cols="2" class="profile-details mt-5">
            <b-col v-show="false">Profilkép</b-col>
            <b-col v-show="false">
              <b-form-group id="input-group-4" label-for="input-4" description="">
                <b-form-file
                  v-model="file1"
                  :state="Boolean(file1)"
                  accept="image/jpeg, image/png"
                  placeholder="Új profilkép kiválasztása"
                  drop-placeholder="Helyezze a képet ide"
                  ref="profileImageFile"
                  @input="onProfilePictureChange"
                ></b-form-file>
              </b-form-group>
            </b-col>
            <b-col>Név</b-col>
            <b-col
              ><b-form-group id="input-group-1" label-for="input-1" description="">
                <b-form-input
                  id="fullName"
                  type="text"
                  required
                  placeholder="Teljes név"
                  class="border"
                  v-model="profileModify.fullName"
                  :disabled="this.getUser.kauId"
                ></b-form-input> </b-form-group
            ></b-col>
            <b-col>Felhasználónév</b-col>
            <b-col>
              <b-form-group id="input-group-1" label-for="input-1" description="">
                <b-form-input
                  id="userName"
                  type="text"
                  required
                  placeholder="Felhasználónév"
                  class="border"
                  v-model="profileModify.userName"
                  disabled
                ></b-form-input> </b-form-group
            ></b-col>
            <b-col>Telefonszám</b-col>
            <b-col
              ><b-form-group id="input-group-1" label-for="input-1" description="">
                <b-form-input
                  id="phoneNumber"
                  type="text"
                  required
                  placeholder="Telefonszám"
                  class="border"
                  v-model="profileModify.phoneNumber"
                ></b-form-input> </b-form-group
            ></b-col>
            <b-col>Email cím</b-col>
            <b-col
              ><b-form-group id="input-group-1" label-for="input-1" description="">
                <b-form-input
                  id="email"
                  type="text"
                  required
                  placeholder="Email cím"
                  class="border"
                  v-model="getUser.email"
                  disabled
                ></b-form-input> </b-form-group
            ></b-col>
            <b-col>Jelszó</b-col>
            <b-col
              ><b-form-group id="input-group-1" label-for="input-1" description="">
                <b-form-input
                  id="password"
                  type="password"
                  required
                  placeholder="Jelszó"
                  class="border"
                  v-model="profileModify.currentPassword"
                ></b-form-input> </b-form-group
            ></b-col>
            <b-col>Új Jelszó</b-col>
            <b-col
              ><b-form-group id="input-group-1" label-for="input-1" description="">
                <b-input-group>
                  <b-form-input
                    id="newPassword"
                    :type="passwordFieldType"
                    required
                    placeholder="Új jelszó"
                    class="border"
                    v-model="profileModify.newPassword"
                    @input="passwordCheck"
                  ></b-form-input>
                  <b-input-group-append>
                    <span class="input-group-text border" @click="switchPasswordVisibility">
                      <eye-icon v-if="passwordFieldType == 'password'" title="Jelszó megjelenítése" />
                      <eye-off-icon v-if="passwordFieldType == 'text'" title="Jelszó elrejtése" />
                    </span>
                  </b-input-group-append>
                </b-input-group> </b-form-group
            ></b-col>
            <b-col>Új jelszó újra</b-col>
            <b-col
              ><b-form-group id="input-group-1" label-for="input-1" description="">
                <b-input-group>
                  <b-form-input
                    id="newPasswordConfirm"
                    :type="passwordFieldType"
                    required
                    placeholder="Új jelszó újra"
                    class="border"
                    v-model="profileModify.newPasswordConfirm"
                  ></b-form-input>
                  <b-input-group-append>
                    <span class="input-group-text border" @click="switchPasswordVisibility">
                      <eye-icon v-if="passwordFieldType == 'password'" title="Jelszó megjelenítése" />
                      <eye-off-icon v-if="passwordFieldType == 'text'" title="Jelszó elrejtése" />
                    </span>
                  </b-input-group-append> </b-input-group
              ></b-form-group>
            </b-col>
          </b-row>
        </b-form>

        <div class="password-validator-container">
          <p v-bind:class="{ password_length_valid: truthyPasswordRulesCount1 }"></p>

          <p v-bind:class="{ uppercase_valid: truthyPasswordRulesCount2 }"></p>

          <p v-bind:class="{ number_valid: truthyPasswordRulesCount3 }"></p>

          <p v-bind:class="{ special_valid: truthyPasswordRulesCount4 }"></p>

          <p v-bind:class="{ hungarian_valid: truthyPasswordRulesCount5 }"></p>
        </div>

        <b-form-group>
          <small
            class="form-text text-left text-muted"
            v-bind:class="{
              'text-success': valid_password_length,
              'ml-1': valid_password_length,
              'ml-4': !valid_password_length
            }"
          >
            Minimum 10 karakter
          </small>
          <small
            class="form-text text-left text-muted"
            v-bind:class="{
              'text-success': contains_uppercase,
              'ml-1': contains_uppercase,
              'ml-4': !contains_uppercase
            }"
          >
            1 nagybetű
          </small>
          <small
            class="form-text text-left text-muted"
            v-bind:class="{
              'text-success': contains_number,
              'ml-1': contains_number,
              'ml-4': !contains_number
            }"
          >
            1 szám
          </small>
          <small
            class="form-text text-left text-muted"
            v-bind:class="{
              'text-success': contains_special,
              'ml-1': contains_special,
              'ml-4': !contains_special
            }"
          >
            1 különleges karakter ( @ $ ! % * ? &)
          </small>
          <small
            class="form-text text-left text-muted"
            v-bind:class="{
              'text-success': contains_hungarian,
              'ml-1': contains_hungarian,
              'ml-4': !contains_hungarian
            }"
          >
            Nem tartalmaz ékezetes karaktert
          </small>
          <small
            class="form-text text-left text-muted"
            v-bind:class="{
              'text-success':
                profileModify.newPassword == profileModify.newPasswordConfirm && profileModify.newPassword != '',
              'ml-1': profileModify.newPassword == profileModify.newPasswordConfirm && profileModify.newPassword,
              'ml-4': !(profileModify.newPassword == profileModify.newPasswordConfirm && profileModify.newPassword)
            }"
          >
            A jelszavak megegyeznek
          </small>
        </b-form-group>

        <b-row class="mb-4 text-center">
          <b-col>
            <b-button size="lg" variant="primary" class="mt-4 w-100" @click="onProfileModifySubmit"
              >Változtatások mentése</b-button
            >
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import EyeIcon from 'vue-material-design-icons/Eye.vue'
import EyeOffIcon from 'vue-material-design-icons/EyeOff.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ProfileEdit',
  components: {
    EyeIcon,
    EyeOffIcon
  },
  data() {
    return {
      file1: null,
      profileModify: {
        fullName: '',
        userName: '',
        phoneNumber: '',
        currentPassword: '',
        newPassword: '',
        newPasswordConfirm: ''
      },
      passwordFieldType: 'password',
      password_length: 0,
      typed: false,
      contains_lowercase: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special: false,
      contains_hungarian: false,
      valid_password_length: false,
      valid_password: false
    }
  },
  created() {
    this.profileModify.fullName = this.getUser.fullName
    this.profileModify.userName = this.getUser.userName
    this.profileModify.phoneNumber = this.getUser.phoneNumber
  },
  computed: {
    ...mapGetters(['getUser', 'isLoading']),
    imageSrc() {
      return this.getUser.imageName
        ? `${window._env_.VUE_APP_API_URL}/api/v1/image/${this.getUser.imageName}`
        : undefined
    },
    hasProfilePic() {
      return this.getUser.imageName ? true : false
    },
    truthyPasswordRulesCount() {
      const rules = [
        this.valid_password_length,
        this.contains_uppercase,
        this.contains_number,
        this.contains_special,
        this.contains_hungarian
      ]
      const count = rules.filter(Boolean).length

      return count
    },
    truthyPasswordRulesCount1() {
      return this.truthyPasswordRulesCount >= 1 ? true : false
    },
    truthyPasswordRulesCount2() {
      return this.truthyPasswordRulesCount >= 2 ? true : false
    },
    truthyPasswordRulesCount3() {
      return this.truthyPasswordRulesCount >= 3 ? true : false
    },
    truthyPasswordRulesCount4() {
      return this.truthyPasswordRulesCount >= 4 ? true : false
    },
    truthyPasswordRulesCount5() {
      return this.truthyPasswordRulesCount >= 5 ? true : false
    }
  },
  methods: {
    passwordCheck() {
      this.password_length = this.profileModify.newPassword.length
      if (this.password_length >= 10) {
        this.valid_password_length = true
      } else {
        this.valid_password_length = false
      }

      if (this.password_length > 0) {
        this.typed = true
      } else {
        this.typed = false
      }
      this.contains_lowercase = /[a-z]/.test(this.profileModify.newPassword)
      this.contains_number = /\d/.test(this.profileModify.newPassword)
      this.contains_uppercase = /[A-Z]/.test(this.profileModify.newPassword)

      const specialPattern = /^(?=.*[@$!%*?&]).*$/
      this.contains_special = specialPattern.test(this.profileModify.newPassword)
      const hungarianCharactersPattern = /^(?:(?![űáéúőóüöí]).)*$/
      this.contains_hungarian = hungarianCharactersPattern.test(this.profileModify.newPassword)

      // Check if the password is valid
      if (this.contains_lowercase == true && this.contains_number == true) {
        this.valid_password = false
        if (this.contains_uppercase == true && this.valid_password_length == true) this.valid_password = true
      } else {
        this.valid_password = false
      }
    },
    switchPasswordVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    showFileSelector() {
      this.$refs.profileImageFile.$el.childNodes[1].click()
    },
    async onProfilePictureChange() {
      if (this.file1) {
        await this.$store.dispatch('deleteImage')
        await this.uploadImage()
      }
      this.file1 = null
      await this.$store.dispatch('getMe')
    },
    async uploadImage() {
      const formData = new FormData()
      formData.append('file', this.file1)
      await this.$store.dispatch('createImage', formData)
    },
    async deleteProfilePic() {
      await this.$store.dispatch('deleteImage')
      await this.$store.dispatch('getMe')
    },
    async onProfileModifySubmit() {
      if (this.file1) {
        await this.$store.dispatch('deleteImage')
        await this.uploadImage()
      }

      const updateBody = {
        userId: this.getUser.id,
        fullName: this.profileModify.fullName,
        userName: this.profileModify.userName,
        phoneNumber: this.profileModify.phoneNumber
      }

      if (
        this.getUser.fullName != this.profileModify.fullName ||
        this.getUser.phoneNumber != this.profileModify.phoneNumber
      ) {
        const phonePattern = /^((?:\+?3|0)6)(?:-|\()?(\d{1,2})(?:-|\))?(\d{3})-?(\d{3,4})/g
        const phoneNumberValid = phonePattern.test(this.profileModify.phoneNumber)

        if (!phoneNumberValid) {
          this.$store.dispatch('notify', {
            newNotification: { type: 'warning', message: 'Telefonszám formátum hibás.' }
          })
          return
        }

        try {
          await this.$store.dispatch('updateUser', updateBody)
          await this.$store.dispatch('getMe')
          this.$router.push('/profile')
        } catch (err) {
          console.log(err)
        }
      }

      if (
        this.profileModify.newPassword.length > 0 ||
        this.profileModify.newPasswordConfirm.length > 0 ||
        this.profileModify.currentPassword.length > 0
      ) {
        // profile password modification

        if (this.profileModify.currentPassword.length == 0) {
          this.$store.dispatch('notify', {
            newNotification: { type: 'warning', message: 'A jelszó módosításhoz a jelenlegi jelszó megadása kötelező.' }
          })
          return
        }

        if (this.profileModify.newPassword.length == 0 || this.profileModify.newPasswordConfirm.length == 0) {
          this.$store.dispatch('notify', {
            newNotification: { type: 'warning', message: 'A jelszó módosításhoz az új jelszavak megadása kötelező.' }
          })
          return
        }

        if (this.profileModify.newPassword != this.profileModify.newPasswordConfirm) {
          this.$store.dispatch('notify', {
            newNotification: { type: 'warning', message: 'Az új jelszavak nem egyeznek.' }
          })
          return
        }

        if (
          !this.contains_lowercase ||
          !this.contains_number ||
          !this.contains_special ||
          !this.valid_password_length ||
          !this.contains_hungarian
        ) {
          this.$store.dispatch('notify', {
            newNotification: { type: 'warning', message: 'Nem megfelelő jelszó erősség!' }
          })
          return
        }

        if (this.email != this.verifyEmail) {
          this.$store.dispatch('notify', {
            newNotification: { type: 'warning', message: 'Az email címek nem egyeznek' }
          })
          return
        }

        if (this.password != this.verifyPassword) {
          this.$store.dispatch('notify', {
            newNotification: { type: 'warning', message: 'A jelszavak nem egyeznek.' }
          })
          return
        }

        try {
          const modifyPassword = {
            email: this.getUser.email,
            password: this.profileModify.currentPassword,
            newPassword: this.profileModify.newPassword
          }

          await this.$store.dispatch('modifyPassword', modifyPassword)

          this.profileModify.currentPassword = this.profileModify.newPassword = this.profileModify.newPasswordConfirm =
            ''
        } catch (err) {
          this.$store.dispatch('notify', {
            newNotification: {
              type: 'danger',
              message: 'A jelszó módosítás nem sikerült. Próbálja meg újból megadni jelenlegi jelszavát.'
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.selectProfilePicture {
  cursor: pointer;
  color: #00903c;
  margin-top: 20px;
  font-weight: bold;
}

.selectProfilePictureRemove {
  cursor: pointer;
  color: #ba3b46;
  margin-top: 10px;
  font-weight: bold;
  font-size: 10px;
}

.profile-picture {
  width: 150px;
  height: 150px;
}

.profile-details > .col {
  margin-top: 0px;
  text-align: left;
}

.profile-details > .col:nth-child(odd) {
  color: var(--color-green);
  font-weight: bold;
  text-align: left;
  padding-top: 10px;
}

.bordered-container {
  max-width: 600px;
  margin: 0;
  border: 0px;
  padding: 0px;
}
</style>
